import React, {useEffect, useState} from 'react';
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Snackbar,
    Stack,
    TextField,
    Typography,
} from '@mui/material';

import {useBulkCreateDipProg, useBulkDeleteDipProg, useGetDipProgDTObyProg} from './Services';

import {DipProg, DipProgDTO} from './types';
import {useGetProgetti} from '../gestversore/Services';
import {useGetDipendentiProg, useGetDropProgettiByRef} from "../../common/Services";
import {DropProgettiApiResponse} from "../../common/types";

interface DropDipProg2Props {
  onClose: () => void;
}

const DropDipProg2: React.FC<DropDipProg2Props> = ({ onClose }) => {

const { mutateAsync: bulkCreateDipProg,isPending: isBulkCreatingDipProg } = useBulkCreateDipProg();
const { mutateAsync: bulkDeleteDipProg,isPending: isBulkDeletingDipProg  } = useBulkDeleteDipProg();

    const { data: DropProgettiApiResponse } = useGetDropProgettiByRef();

  // const { data: ProgettiApiResponse } = useGetProgetti(2);
  const { data: DipendentiApiResponse } = useGetDipendentiProg(2, '');

  const [dipendentiList, setDipendentiList] = useState<DipProgDTO[]>([]);
  const [projectDipendenti, setProjectDipendenti] = useState<Record<string, DipProgDTO[]>>({});
  const [selectedProgetto, setSelectedProgetto] = useState<string>('');
  const [selectedAvailableIds, setSelectedAvailableIds] = useState<Set<string>>(new Set());
  const [selectedAssignedIds, setSelectedAssignedIds] = useState<Set<string>>(new Set());

  const [saveMessageOpen, setSaveMessageOpen] = useState(false);
  const [initialAssignedDipendenti, setInitialAssignedDipendenti] = useState<DipProgDTO[]>([]);

  const { data: DipProgDTOApiResponse } = useGetDipProgDTObyProg(selectedProgetto);

  const codprog = selectedProgetto.trim();
  const assignedList = projectDipendenti[codprog] || [];

  useEffect(() => {
    if (
      selectedProgetto &&
      DipendentiApiResponse?.results &&
      DipProgDTOApiResponse?.results
    ) {
      const codprog = selectedProgetto.trim();
      const dipProgs = DipProgDTOApiResponse.results;
      const assignedDipIds = new Set<string>();

      const assigned: DipProgDTO[] = dipProgs
        .filter((dp) => dp.codprog?.trim() === codprog && dp.coddip?.trim())
        .map((dp) => {
          const coddip = dp.coddip?.trim()!;

          assignedDipIds.add(coddip);

          return {
            coddip,
            nomedip: dp.nomedip ?? '',
            codprog,
            desprog: dp.desprog ?? '',
            molt: dp.molt ?? 1,
          };
        })
        .sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? ''));

      const unassigned: DipProgDTO[] = DipendentiApiResponse.results
        .filter((d) => !assignedDipIds.has(d.coddip?.trim() || ''))
        .map((d) => ({
          coddip: d.coddip?.trim(),
          nomedip: d.nomedip ?? '',
          codprog: '',
          desprog: '',
        }))
        .sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? ''));

      setProjectDipendenti({ [codprog]: assigned });
      setDipendentiList(unassigned);
      setInitialAssignedDipendenti(assigned);

      setSelectedAvailableIds(new Set());
      setSelectedAssignedIds(new Set());
    }
  }, [selectedProgetto, DipendentiApiResponse, DipProgDTOApiResponse]);


  const handleSubmit = async () => {
  try {
    const codprog = selectedProgetto.trim();

    const currentAssigned =
      projectDipendenti[codprog] || [];

    const currentIds = new Set(
      currentAssigned.map((d) => d.coddip)
    );

    const initialIds = new Set(
      initialAssignedDipendenti.map((d) => d.coddip)
    );

    const toDelete = initialAssignedDipendenti
      .filter((d) => !currentIds.has(d.coddip))
      .map((d) => `2-${codprog}-${d.coddip}`);

    const toCreate: DipProg[] = currentAssigned
      .filter((d) => !initialIds.has(d.coddip))
      .map((d) => ({
        id: `2-${codprog}-${d.coddip}`,
        coddip: d.coddip,
        codprog,
        ditta: 2,
        molt: d.molt ?? 1,
        nomedip: d.nomedip,
        desprog: d.desprog,
      }));

    if (toDelete.length) {
      await bulkDeleteDipProg(toDelete);
    }

    if (toCreate.length) {
      await bulkCreateDipProg(toCreate);
    }

    setSaveMessageOpen(true);
  } catch (error) {
    console.error("Error submitting:", error);
  }
};



  const moveSelectedToAssigned = () => {
    if (!codprog) return;

    const moving = dipendentiList.filter((d) =>
      selectedAvailableIds.has(d.coddip || '')
    );

    if (!moving.length) return;

    setDipendentiList((prev) =>
      prev.filter((d) => !selectedAvailableIds.has(d.coddip || ''))
    );

    setProjectDipendenti((prev) => ({
      ...prev,
      [codprog]: [
        ...(prev[codprog] || []),
        ...moving.map((d) => ({
          ...d,
          codprog,
          molt: d.molt ?? 1,
        })),
      ].sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? '')),
    }));

    setSelectedAvailableIds(new Set());
  };

  const moveAllToAssigned = () => {
    if (!codprog || !dipendentiList.length) return;

    setProjectDipendenti((prev) => ({
      ...prev,
      [codprog]: [
        ...(prev[codprog] || []),
        ...dipendentiList.map((d) => ({
          ...d,
          codprog,
          molt: d.molt ?? 1,
        })),
      ].sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? '')),
    }));

    setDipendentiList([]);
    setSelectedAvailableIds(new Set());
  };

  const moveSelectedToAvailable = () => {
    if (!codprog) return;

    const moving = assignedList.filter((d) =>
      selectedAssignedIds.has(d.coddip || '')
    );

    if (!moving.length) return;

    setProjectDipendenti((prev) => ({
      ...prev,
      [codprog]: assignedList.filter(
        (d) => !selectedAssignedIds.has(d.coddip || '')
      ),
    }));

    setDipendentiList((prev) =>
      [
        ...prev,
        ...moving.map((d) => ({
          ...d,
          codprog: '',
          desprog: '',
        })),
      ].sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? ''))
    );

    setSelectedAssignedIds(new Set());
  };

  const moveAllToAvailable = () => {
    if (!codprog || !assignedList.length) return;

    setDipendentiList((prev) =>
      [
        ...prev,
        ...assignedList.map((d) => ({
          ...d,
          codprog: '',
          desprog: '',
        })),
      ].sort((a, b) => (a.nomedip ?? '').localeCompare(b.nomedip ?? ''))
    );

    setProjectDipendenti((prev) => ({
      ...prev,
      [codprog]: [],
    }));

    setSelectedAssignedIds(new Set());
  };

  const selectedProjectDescription =
    DropProgettiApiResponse?.results.find(
      (p) => p.codprog?.trim() === selectedProgetto.trim()
    )?.desprog || 'Risorse assegnate';

  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="xl">
      <DialogTitle>
        <Typography variant="h5">
          Assegna Risorse ai Progetti (NB: Attenzione al moltiplicatore)
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box mb={3} display="flex" justifyContent="center">
          <Autocomplete
            options={(DropProgettiApiResponse?.results || [])
              .slice()
              .sort((a, b) => {
                const aCode = a.codprog?.trim() || '';
                const bCode = b.codprog?.trim() || '';
                return bCode.localeCompare(aCode);
              })}
            getOptionLabel={(option) =>
              `(${option.codprog?.trim()}) ${option.desprog}`
            }
            value={
              DropProgettiApiResponse?.results.find(
                (p) => p.codprog?.trim() === selectedProgetto
              ) || null
            }
            onChange={(event, newValue) => {
              setSelectedProgetto(newValue?.codprog?.trim() || '');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Seleziona un progetto"
                variant="outlined"
                size="small"
              />
            )}
            sx={{ minWidth: 500 }}
          />
        </Box>

        <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
          <Box
            sx={{
              width: 350,
              height: 500,
              overflowY: 'auto',
              border: '1px solid gray',
              borderRadius: 2,
              p: 2,
              fontSize: '0.7rem',
            }}
          >
            <Typography variant="h6" mb={1}>
              Risorse disponibili
            </Typography>

            {dipendentiList.map((dip) => {
              const id = dip.coddip || '';
              const selected = selectedAvailableIds.has(id);

              return (
                <Box
                  key={id}
                  onClick={() => {
                    setSelectedAvailableIds((prev) => {
                      const next = new Set(prev);
                      next.has(id) ? next.delete(id) : next.add(id);
                      return next;
                    });
                  }}
                  sx={{
                    mb: 1,
                    p: 1,
                    bgcolor: selected ? '#90caf9' : 'lightgray',
                    borderRadius: 1,
                    cursor: 'pointer',
                  }}
                >
                  {dip.nomedip}
                </Box>
              );
            })}
          </Box>

          <Stack spacing={2}>
            <Button
              variant="contained"
              onClick={moveSelectedToAssigned}
              disabled={!selectedProgetto || selectedAvailableIds.size === 0}
            >
              &gt;
            </Button>

            <Button
              variant="contained"
              onClick={moveAllToAssigned}
              disabled={!selectedProgetto || dipendentiList.length === 0}
            >
              &gt;&gt;
            </Button>

            <Button
              variant="contained"
              onClick={moveAllToAvailable}
              disabled={!selectedProgetto || assignedList.length === 0}
            >
              &lt;&lt;
            </Button>

             <Button
              variant="contained"
              onClick={moveSelectedToAvailable}
              disabled={!selectedProgetto || selectedAssignedIds.size === 0}
            >
              &lt;
            </Button>

          </Stack>

          <Box
            sx={{
              width: 450,
              height: 500,
              overflowY: 'auto',
              border: '1px solid #1976d2',
              borderRadius: 2,
              p: 2,
              fontSize: '0.7rem',
            }}
          >
            <Typography variant="h6" mb={1}>
              {selectedProjectDescription}
            </Typography>

            {assignedList.map((dip) => {
              const id = dip.coddip || '';
              const selected = selectedAssignedIds.has(id);

              return (
                <Box
                  key={id}
                  onClick={() => {
                    setSelectedAssignedIds((prev) => {
                      const next = new Set(prev);
                      next.has(id) ? next.delete(id) : next.add(id);
                      return next;
                    });
                  }}
                  sx={{
                    mb: 1,
                    p: 1,
                    bgcolor: selected ? '#90caf9' : '#e3f2fd',
                    borderRadius: 1,
                    cursor: 'pointer',
                  }}
                >
                  <span>{dip.nomedip}</span>
                  <strong> (x {dip.molt ?? 1})</strong>
                </Box>
              );
            })}
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}   disabled={isBulkCreatingDipProg || isBulkDeletingDipProg}>
          Chiudi
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          color="primary"
          disabled={isBulkCreatingDipProg || isBulkDeletingDipProg || !selectedProgetto}
          startIcon={
            isBulkCreatingDipProg || isBulkDeletingDipProg ? (
              <CircularProgress color="inherit" size={25} />
            ) : null
          }
        >
          Salva
        </Button>
      </DialogActions>

      <Snackbar
        open={saveMessageOpen}
        autoHideDuration={3000}
        onClose={() => setSaveMessageOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ mb: 5 }}
      >
        <Alert
          onClose={() => setSaveMessageOpen(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          Salvataggio completato con successo!
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default DropDipProg2;